module.exports = __webpack_public_path__ + "img/23.47e9b49b.png";